import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function BenchmarkError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot create benchmark'}
    </Alert>
  );
}

export { BenchmarkError };
